import { APIStatus } from "@application/common/enums/api-status";
import { createCompanyAsync, fetchAllCompaniesAsync, fetchCompaniesAsync, getAllByUserAsync, getCompanyByIdAsync, updateCompanyAsync, updateStatusAsync } from "./companyThunk";
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    status: APIStatus.IDLE,
    companies: {
        items: [],
        pageNumber: 0,
        totalPages: 0,
        totalCount: 0,
        hasPreviousPage: false,
        hasNextPage: false
    },
    allCompanies: [],
    userCompanies: [],
    selectedCompany: null,
    apiError: undefined
};
export const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        resetCompanyState: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearSelectedCompany: (state) => {
            state.selectedCompany = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompaniesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(fetchCompaniesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.companies = action.payload;
        })
            .addCase(fetchCompaniesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Fetch All Companies
        builder
            .addCase(fetchAllCompaniesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(fetchAllCompaniesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.allCompanies = action.payload;
        })
            .addCase(fetchAllCompaniesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Create Company
        builder
            .addCase(createCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.companies) {
                if (state.companies) {
                    state.companies.items.push(action.payload);
                }
            }
        })
            .addCase(createCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Update Company
        builder
            .addCase(updateCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.companies) {
                const index = state.companies.items.findIndex(c => c.id === action.payload.id);
                if (index !== -1) {
                    state.companies.items[index] = action.payload;
                }
            }
        })
            .addCase(updateCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Get All By User
        builder
            .addCase(getAllByUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllByUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.userCompanies = action.payload;
        })
            .addCase(getAllByUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Update Status
        builder
            .addCase(updateStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateStatusAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(updateStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        // Get Company By Id
        builder
            .addCase(getCompanyByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCompanyByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedCompany = action.payload;
        })
            .addCase(getCompanyByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    },
});
export const { resetCompanyState, clearSelectedCompany } = companySlice.actions;
export default companySlice.reducer;
